import { customerApi } from './customer.api';

const actionPrefix = (actionType) => `Customer/${actionType}`;

export const SET_CUSTOMER = actionPrefix`SET_CUSTOMER`;
export const setCustomer = (customer) => ({ type: SET_CUSTOMER, payload: customer });

export const fetchCustomer =
  (bypassErrorCodes = []) =>
  (dispatch) =>
    customerApi.fetch(bypassErrorCodes).then((response) => dispatch(setCustomer(response)));
